import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LinkComponent } from '../../atoms/link/link.component';
import { IconComponent } from '../../atoms/icon/icon.component';

import LinkType from '../../../shared/enums/link-type.enums';
import { Sizes, Colors } from '../../../shared/enums/shared.enums';
import CardType from '../../../shared/enums/card-type.eums';
import { ButtonComponent } from '../button/button.component';
import { ButtonType } from '../../../shared/enums/button-type.enums';
import ViewportType from '../../../shared/enums/viewport-type.enums';
import { HrefType } from '../../../shared/enums/href-type.enums';
import { CapitalizePipe } from '../../capitalize.pipe';

@Component({
  selector: 'hdi-card',
  standalone: true,
  imports: [
    CommonModule,
    LinkComponent,
    IconComponent,
    ButtonComponent,
    CapitalizePipe,
  ],
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss',
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class CardComponent {
  @Input() viewport: ViewportType = ViewportType.desktop;
  @Input() type? = CardType.CONTACT;
  @Input() title? = '';
  @Input() subtitle? = '';
  @Input() date? = '';
  @Input() location? = '';
  @Input() disabled = false;
  Sizes = Sizes;
  /* Icon props */
  @Input() icon?: string;
  @Input() iconColor?: Colors = Colors.BLACK;
  /* Link props */
  @Input() linkType: LinkType = LinkType.PRIMARY_ARROW;
  @Input() textLink = '';
  @Input() link? = '';
  @Input() linkTarget? = '_self';
  @Input() linkRel? = 'follow';
  @Input() linkTitle = '';
  /* text-btn props */
  @Input() strongText? = '';

  @Input() btnLabel? = '';
  @Input() btnHref?: string;
  @Input() btnHrefType?: HrefType;
  @Input() btnTarget? = '_self';
  @Input() btnType = ButtonType.TERTIARY;
  @Input() btnColor? = Colors.BLACK;

  Colors = Colors;
  HrefType = HrefType;
  LinkType = LinkType;
  constructor() {}

  isEmail(text: string): boolean {
    return text.includes('@');
  }
}
